module.exports = __webpack_public_path__ + "img/9788961771672.abaedaaf.jpg";